import { isCategoryAllowed, COOKIE_CATEGORIES, setItemWithConsent } from './cookieConsent';

/**
 * Utility functions for detecting and managing user language preferences
 */

/**
 * Detect browser's default language
 * @returns {string} 'en' or 'de'
 */
export const detectBrowserLanguage = () => {
  // Check browser language
  const browserLang = navigator.language || navigator.userLanguage || '';
  
  // If browser language contains 'en', return 'en'
  // Otherwise default to 'de' (German)
  return browserLang.toLowerCase().includes('en') ? 'en' : 'de';
};

/**
 * Get initial language based on localStorage or browser detection
 * Priority: localStorage > browser detection > default (de)
 * @returns {string} 'en' or 'de'
 */
export const getInitialLanguage = () => {
  // Try to get stored language (only if functional cookies are allowed)
  const storedLanguage = localStorage.getItem('appLanguage');
  
  if (storedLanguage && (storedLanguage === 'en' || storedLanguage === 'de')) {
    return storedLanguage;
  }
  
  // Detect from browser (always allowed, doesn't set cookies)
  const detectedLanguage = detectBrowserLanguage();
  
  // Store detected language only if functional cookies are allowed
  setItemWithConsent('appLanguage', detectedLanguage, COOKIE_CATEGORIES.FUNCTIONAL);
  
  return detectedLanguage;
};
